import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tapfiliate = defineConnector({
  identifier: "tapfiliate",
  name: "Tapfiliate",
  tagLine: "Affiliate tracking and management",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.tapfiliate\\.com/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Tapfiliate](https://tapfiliate.com/) and navigate to your account settings to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.tapfiliate.com/1.6/me/",
  },
});
